export default {
  APP_NAME: 'SahabatOMG',
  registration: {
    dealerTypes: {
      INDIVIDUAL: 'INDIVIDUAL',
      COMPANY: 'COMPANY'
    },
    companyCategory: {
      PARENT: 'PARENT',
      CHILD: 'CHILD',
      INDIVIDUAL: 'INDIVIDUAL'
    },
    sampleMailId: 'johndoe@blibli.com',
    noReplyMailId: 'no-reply@blibli.com',
    buildingStatus: [
      {
        label: 'selfOwned',
        value: 'OWN'
      },
      {
        label: 'rent',
        value: 'RENT'
      }
    ],
    picRoles: {
      DIRECTOR: 'DIRECTOR',
      REPRESENTATIVE: 'REPRESENTATIVE',
      FINANCE: 'FINANCE',
      SALES: 'SALES',
      OPERATIONAL: 'OPERATIONAL',
      PURCHASING: 'PURCHASING',
      OTHERS: 'OTHERS'
    },
    registrationStepsRouteMap: {
      REGISTRATION_TYPE: 'dealerType',
      DEALER_DATA: 'dealerInfo',
      PIC_DATA: 'picInfo',
      SUPPORTING_DATA: 'supportDocs',
      CREDIT_LIMIT_DATA: 'termsOfPayment'
    },
    ACCOUNT_NOT_REGISTERED: 'ACCOUNT_NOT_REGISTERED'
  },
  passwordStrength: {
    ENABLED: 'ENABLED',
    DISABLED: 'DISABLED'
  },
  media: {
    COMMON_FILE_SIZE: 10,
    MAX_ALLOWED_FILES: 20,
    MAX_IMAGE_ITERATION_COUNT: 15
  },
  regex: {
    alphabet: /^[A-Za-z ]+$/,
    number: /^\d+$/,
    email: /^(([^<>()[\]\\.,;:\s@\\"]+(\.[^<>()[\]\\.,;:\s@\\"]+)*)|(\\".+\\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    password: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\w\s]).{8,20}$/,
    loginPassword: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\w\s]).{8,}$/,
    phoneNumber: /^(0|62)\d{8,14}$/,
    alphaNumeric: /^[A-Za-z0-9]+$/,
    notEmptyRegex: /^(?!\s*$).+/,
    ktpNumber: /^\d{16}$/,
    npwpNumber: /^\d{15,16}$/
  },
  companyRegistrationStatus: {
    APPROVED: 'APPROVED',
    APPROVAL_PENDING: 'APPROVAL_PENDING',
    REJECTED: 'REJECTED',
    EMAIL_VERIFICATION_DONE: 'EMAIL_VERIFICATION_DONE'
  },
  buildingStatus: {
    OTHERS: 'Lainnya',
    OWN: 'Milik sendiri',
    RENT: 'Sewa'
  },
  SECTION_LIST: [
    'companyInfo',
    'legalDocs',
    'sellerInfo',
    'ownerDetails',
    'supportDocs'
  ],
  errorResponse: {
    EMAIL_VERIFICATION_PENDING: 'EMAIL_VERIFICATION_PENDING',
    EMAIL_VERIFICATION_LINK_EXPIRED_RESEND: 'EMAIL_VERIFICATION_LINK_EXPIRED_RESEND',
    PRODUCT_DISABLED: 'PRODUCT_DISABLED',
    COMPANY_ADDRESS: 'COMPANY_ADDRESS',
    DIRECTOR_PHONE_NUMBER_INVALID: 'DIRECTOR_PHONE_NUMBER_INVALID'
  },
  VERIFICATION_MAIL_NOT_SENT: 'VERIFICATION_MAIL_NOT_SENT',
  RESET_PASSWORD_MAIL_NOT_SENT: 'RESET_PASSWORD_MAIL_NOT_SENT',
  currencyFormat: 'Rp',
  SESSION_UPDATED_DATE: 'sessionUpdatedDate',
  IS_REJECTED_REASON_VIEWED: 'isRejectedReasonViewed',
  CART_EMPTY: 'CART_EMPTY',
  order: {
    QUOTATION_STATUS: 'QUOTATION_STATUS',
    orderList: {
      RECORDS_PER_PAGE: 10
    },
    status: {
      ALL_STATUS: 'ALL_STATUS',
      QUOTATION_CREATED: 'QUOTATION_CREATED',
      QUOTATION_PROCESSED: 'QUOTATION_PROCESSED',
      QUOTATION_APPROVED: 'QUOTATION_APPROVED',
      QUOTATION_REJECTED: 'QUOTATION_REJECTED',
      QUOTATION_EXPIRED: 'QUOTATION_EXPIRED',
      QUOTATION_APPROVAL: 'QUOTATION_APPROVAL',
      PO_CREATED: 'PO_CREATED',
      IN_PACKING: 'IN_PACKING',
      IN_DELIVERY: 'IN_DELIVERY',
      DELIVERED: 'DELIVERED',
      ORDER_COMPLETED: 'ORDER_COMPLETED',
      APPROVED: 'DEALER_APPROVED',
      REJECTED: 'DEALER_REJECTED'
    },
    otpType: {
      EMAIL: 'EMAIL',
      WHATSAPP: 'WHATSAPP'
    },
    errorCode: {
      USER_DAILY_OTP_RESEND_LIMIT_EXCEEDED: 'USER_DAILY_OTP_RESEND_LIMIT_EXCEEDED',
      QUOTATION_OTP_VERIFICATION_IN_PROGRESS: 'QUOTATION_OTP_VERIFICATION_IN_PROGRESS',
      WRONG_OTP: 'WRONG_OTP',
      OTP_VERIFIED: 'OTP_VERIFIED',
      USER_VERIFY_LIMIT_EXCEEDED: 'USER_VERIFY_LIMIT_EXCEEDED',
      OTP_RESEND_COUNT_LIMIT_REACHED: 'OTP_RESEND_COUNT_LIMIT_REACHED',
      CANNOT_VERIFY_OTP: 'CANNOT_VERIFY_OTP',
      FINAL_RESEND_LIMIT_WARNING: 'FINAL_RESEND_LIMIT_WARNING',
      OTP_RESEND_COUNT_LIMIT_REACHED_WHATSAPP: 'OTP_RESEND_COUNT_LIMIT_REACHED_WHATSAPP',
      OTP_RESEND_COUNT_LIMIT_REACHED_EMAIL: 'OTP_RESEND_COUNT_LIMIT_REACHED_EMAIL'
    },
    preCheckOtpErroCode: {
      CANNOT_RESEND_WITHIN_LIMIT: 'CANNOT_RESEND_WITHIN_LIMIT',
      SHOW_OTP_POP_UP: 'SHOW_OTP_POP_UP',
      OTP_RESEND_COUNT_LIMIT_REACHED_PHONE: 'OTP_RESEND_COUNT_LIMIT_REACHED_PHONE',
      OTP_RESEND_COUNT_LIMIT_REACHED_EMAIL: 'OTP_RESEND_COUNT_LIMIT_REACHED_EMAIL',
      QUOTATION_OTP_VERIFICATION_IN_PROGRESS_BY_OTHER_USER: 'QUOTATION_OTP_VERIFICATION_IN_PROGRESS_BY_OTHER_USER',
      INVALID_STATUS: 'INVALID_STATUS',
      SHOW_OTP_TYPE: 'SHOW_OTP_TYPE'
    }
  },
  scanImei: {
    status: {
      ACCEPTED: 'ACCEPTED',
      WAITING: 'WAITING',
      REJECTED: 'REJECTED'
    },
    errorCodes: {
      NO_DATA_FOR_EXCEL: 'NO_DATA_FOR_EXCEL',
      INVALID_HEADER: 'INVALID_HEADER',
      SHEET_NAME_NOT_FOUND: 'SHEET_NAME_NOT_FOUND'
    }
  },
  cashback: {
    status: {
      FILED: 'FILED',
      ACCEPTED: 'ACCEPTED',
      REJECTED: 'REJECTED',
      NOT_FILED: 'NOT_FILED',
      WAITING: 'WAITING'
    }
  },
  dateFormat: {
    DD_MON_YYYY: { year: 'numeric', month: 'short', day: 'numeric' },
    DD_MONTH_YYYY: { year: 'numeric', month: 'long', day: 'numeric' },
    DAY_DD_MON_YYYY: { year: 'numeric', month: 'short', day: 'numeric', weekday: 'long' },
    DD_MON_YYYY_HH_MM: { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', hourCycle: 'h23', minute: '2-digit' }
  },
  timeZone: {
    IST: 'IST',
    IST_OFFSET: -330,
    WIB: 'WIB',
    WIB_OFFSET: -420,
    WITA: 'WITA',
    WITA_OFFSET: -480,
    WIT: 'WIT',
    WIT_OFFSET: -540,
    UTC: 'UTC',
    UTC_OFFSET: 0
  },
  badgeColours: {
    BLUE: 'blue',
    YELLOW: 'yellow',
    GREEN: 'green',
    GRAY: 'gray'
  },
  mission: {
    RECORDS_PER_PAGE: 20,
    status: {
      UP_COMING: 'UP_COMING',
      ACTIVE: 'ACTIVE',
      ENDED: 'ENDED'
    }
  },
  theme: {
    DARK: 'DARK',
    LIGHT: 'LIGHT',
    SYSTEM: 'SYSTEM'
  },
  TNC_TYPES: {
    REGISTRATION: 'registration',
    PROFILE: 'profile'
  },
  creditNotes: {
    RECORDS_PER_PAGE: 20,
    claimType: { QUOTATION: 'QUOTATION', BILL: 'BILL' },
    filterType: { INACTIVE: 'INACTIVE', ACTIVE: 'ACTIVE', CLAIM: 'CLAIM', EXPIRY: 'EXPIRY' },
    status: {
      NOT_ACTIVATED: 'NOT_ACTIVATED',
      ACTIVATION_PENDING: 'ACTIVATION_PENDING',
      ACTIVATION_REJECTED: 'ACTIVATION_REJECTED',
      ACTIVATED: 'ACTIVATED',
      CLAIM_PENDING: 'CLAIM_PENDING',
      CLAIM_REJECTED: 'CLAIM_REJECTED',
      CLAIMED: 'CLAIMED',
      EXPIRED: 'EXPIRED'
    }
  }
}
